import { en } from '@/i18n/en';
import { ptBR } from '@/i18n/pt-BR';
import type { Dictionary, Locale } from '@/i18n/types';

export type { Dictionary, Locale };

export const detectLocale = (languages: readonly string[]): Locale => {
  const first = languages.find((language) => language.length > 0);
  return first?.toLowerCase().startsWith('en') === true ? 'en' : 'pt-BR';
};

export const dictionaryFor = (locale: Locale): Dictionary => (locale === 'en' ? en : ptBR);
